export enum PurchaseVariantSelectionType {
    AllActiveVariants = 'AllActiveVariants',
    AllActiveVariantsWithInventory = 'AllActiveVariantsWithInventory',
    SpecificVariants = 'SpecificVariants',
}

export enum PurchaseLinkPriceOption {
    AllActive = 'AllActive',
    Specific = 'Specific',
}
